import React from 'react'
import styled from 'styled-components'
import {
  FlexColumnContainer, FlexContainer, StyledLabel, GrayButton, SquareImg
} from '../StyledComponents'

const ImagePickerContainer = styled(FlexContainer)`
  justify-content: space-between;
  align-items: center;
`

const StyledTitle = styled.div`
  margin-bottom: 0;
  font-weight: 500;
`

const StyledAuthor = styled.div`
  margin-bottom: 0;
`

const StyledFlexColumnContainer = styled(FlexColumnContainer)`
  width: 55%;
`

const OuterContainer = styled(FlexColumnContainer)`
  width: 100%;
`

export default class ImagePicker extends React.Component {
  render () {
    let imagePicker
    if (!this.props.image || Object.keys(this.props.image).length === 0) {
      imagePicker = (
        <div>
          <GrayButton small='true' onClick={this.props.toggleModal}
            error={this.props.error}>
            Choose
          </GrayButton>
        </div>
      )
    } else {
      const { image, name, author } = this.props.image
      imagePicker = (
        <ImagePickerContainer name={this.props.name}>
          <SquareImg image={image} />
          <StyledFlexColumnContainer>
            <StyledTitle>{name}</StyledTitle>
            <StyledAuthor>{author}</StyledAuthor>
          </StyledFlexColumnContainer>
          <GrayButton small='true' onClick={this.props.toggleModal} error={this.props.error}>
            Change
          </GrayButton>
        </ImagePickerContainer>
      )
    }

    return (
      <OuterContainer>
        <StyledLabel error={this.props.error}>{this.props.label}</StyledLabel>
        {imagePicker}
      </OuterContainer>
    )
  }
}
